// frontend/src/config/api/endpoints/coreEndpoints.ts
/**
 * Pensado por: Alcélio Gomes
 * Codificado em coautoria: Claude Code
 * 🚀 NeuroAgentes
 * 
 * AUDITORIA: Endpoints core (auth, whatsapp, agents, webhooks, projects, user).
 */

export const authEndpoints = {
  login: '/api/auth/login',
  register: '/api/auth/register',
  logout: '/api/auth/logout',
  verify: '/api/auth/verify',
  refreshToken: '/api/auth/refresh-token',
  checkEmail: '/api/auth/check-email',
  csrfToken: '/api/auth/csrf-token',
  switchProject: '/api/auth/switch-project',
  googleUrl: '/api/auth/google/url',
  googleLogin: '/api/auth/google/login',
  verifyEmail: (token: string) => `/api/auth/verify-email/${token}`,
  resendVerification: '/api/auth/resend-verification',
};

export const whatsappEndpoints = {
  connect: '/api/whatsapp/connect',
  disconnect: '/api/whatsapp/disconnect',
  status: '/api/whatsapp/status',
  qrcode: '/api/whatsapp/qrcode',
};

export const agentsEndpoints = {
  list: '/api/agents',
  create: '/api/agents',
  update: (id: string) => `/api/agents/${id}`,
  delete: (id: string) => `/api/agents/${id}`,
  get: (id: string) => `/api/agents/${id}`,
  listByProject: (projectId: string) => `/api/agents/projects/${projectId}/list`,
  listByOrganization: (projectId: string) => `/api/agents/organizations/${projectId}/list`,
};

export const webhooksEndpoints = {
  list: '/api/webhooks',
  create: '/api/webhooks',
  update: (id: string) => `/api/webhooks/${id}`,
  delete: (id: string) => `/api/webhooks/${id}`,
  test: (id: string) => `/api/webhooks/${id}/test`,
};

export const projectsEndpoints = {
  list: '/api/projects',
  create: '/api/projects',
  get: (id: string) => `/api/projects/${id}`,
  update: (id: string) => `/api/projects/${id}`,
  delete: (id: string) => `/api/projects/${id}`,
};

export const userEndpoints = {
  profile: '/api/user/profile',
  updateProfile: '/api/user/profile',
  changePassword: '/api/user/change-password',
  tokens: '/api/user/tokens',
};
